import { Fragment, useState } from "react";
import TicketSaleList from "./TicketSaleList";
import Tabs from "../../../../elements/Tabs";
import { Link, useOutletContext } from "react-router-dom";
import TicketSaleExportsList from "./TicketSaleExportList";
import { t } from "i18next";

// Main Ticket Sales Component
const TicketSaleManage = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { event, selectedLanguage } = useOutletContext();

  // Tab items configuration
  const tabs = [
    {
      label: t("Preview"),
      content: (
        <Fragment>
          <TicketSaleList />
        </Fragment>
      ),
    },
    {
      label: t("Exports"),
      content: <TicketSaleExportsList />,
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white px-4 md:px-6 pt-6 pb-0">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <Link
              to={`/${selectedLanguage}/user/myEvent/report/${event?.data?.uid}`}
            >
              <div className="flex items-center gap-2 text-blue-600 mb-6 hover:text-blue-700 transition-colors">
                <i className="fas fa-chevron-left text-sm"></i>
                <span className="text-sm font-medium">
                  {t("Event Reports")}
                </span>
              </div>
            </Link>

            <div className="flex items-start justify-between mb-8">
              <div>
                <h1
                  className="text-2xl md:text-5xl font-bold mb-3"
                  style={{ color: "#1f2937" }}
                >
                  {t("Sales by ticket type")}
                </h1>
              </div>
            </div>
          </div>

          {/* Custom Tabs Design */}
          <Tabs
            items={tabs}
            setSelectedIndex={setSelectedIndex}
            selectedIndex={selectedIndex}
            contentClass={"p-0 md:p-auto"}
          />
        </div>
      </div>
    </div>
  );
};

export default TicketSaleManage;
